import React, { useContext } from 'react';
import { LocaleContext, ModalForm, PageHeader } from 'shared';

import * as AccountForm from '../accountForm';

import { AccountDetailsWrapper } from './AccountDetails.styles';
import {
  ACCOUNT_NAME_MODAL,
  AccountDetailsProps,
  COMPANY_DETAILS_MODAL,
  CONTACT_INFORMATION_MODAL,
} from './AccountDetails.types';
import { AccountName } from './accountName/AccountName';
import { CompanyDetails } from './companyDetails/CompanyDetails';
import { ContactInformation } from './contactInformation/ContactInformation';

export const AccountDetails = ({ account, openedModal, onSetOpenedModal, onSubmit }: AccountDetailsProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <AccountDetailsWrapper>
      <PageHeader>{localeContext.formatMessage({ id: 'ACCOUNT.TITLE' })}</PageHeader>
      <AccountName account={account} onOpenEditModal={onSetOpenedModal(ACCOUNT_NAME_MODAL)} />
      {account.companyData && (
        <CompanyDetails
          style={{ marginTop: '2rem' }}
          account={account}
          onOpenEditModal={onSetOpenedModal(COMPANY_DETAILS_MODAL)}
        />
      )}
      {account.contactPerson && (
        <ContactInformation
          style={{ marginTop: '2rem' }}
          account={account}
          onOpenEditModal={onSetOpenedModal(CONTACT_INFORMATION_MODAL)}
        />
      )}
      <ModalForm
        name={openedModal ? localeContext.formatMessage({ id: `ACCOUNT.${openedModal}` }) : ''}
        submitName={localeContext.formatMessage({ id: 'GENERAL.SAVE' })}
        className="edit-account-form"
        onSubmit={onSubmit}
        isOpen={!!openedModal}
        onClose={onSetOpenedModal(null)}
        initialValues={account}
      >
        {openedModal === ACCOUNT_NAME_MODAL && <AccountForm.AccountName />}
        {openedModal === COMPANY_DETAILS_MODAL && <AccountForm.CompanyDetails />}
        {openedModal === CONTACT_INFORMATION_MODAL && <AccountForm.ContactInformation />}
      </ModalForm>
    </AccountDetailsWrapper>
  );
};
